import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import EmptyStateImage from '../../assets/emptystate.svg';

const ChangeEventEmptyState = () => {
  return /* @__PURE__ */ React.createElement(Grid, { container: true, justifyContent: "center", direction: "column", alignItems: "center" }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, "No change events to display yet.")), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: EmptyStateImage,
      alt: "EmptyState",
      "data-testid": "emptyStateImg"
    }
  )));
};

export { ChangeEventEmptyState };
//# sourceMappingURL=ChangeEventEmptyState.esm.js.map
